import { __awaiter, __generator } from "tslib";
import { APP_DEFINITION_ID } from '@wix/wixstores-client-core';
import { Theme } from '@wix/payment-methods-banner/dist/src/types/Theme';
import { SPECS } from '../../../constants';
export var getPaymentMethodsBannerProps = function (siteStore, options) { return __awaiter(void 0, void 0, void 0, function () {
    var shouldFixGetClientConfigBlockingWidgets;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                shouldFixGetClientConfigBlockingWidgets = siteStore.experiments.enabled(SPECS.FixGetClientConfigBlockingWidgets);
                if (!shouldFixGetClientConfigBlockingWidgets) return [3 /*break*/, 2];
                return [4 /*yield*/, siteStore.loadClientConfig()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, {
                    meta: {
                        appDefId: APP_DEFINITION_ID,
                        appInstanceId: siteStore.storeId,
                        appInstance: siteStore.instanceManager.getInstance(),
                        productId: options.productId,
                        msid: siteStore.storeId,
                        host: siteStore.location.baseUrl,
                        visitorId: siteStore.uuid,
                    },
                    amount: options.amount,
                    currency: siteStore.getCurrentCurrency(),
                    demoMode: siteStore.isEditorMode() || siteStore.isPreviewMode(),
                    deviceType: siteStore.isMobile() ? 'mobile' : 'desktop',
                    isSSR: siteStore.isSSR(),
                    locale: siteStore.locale,
                    theme: options.theme ? options.theme : Theme.Light,
                    onFullLoad: options.onFullLoad,
                    onEmpty: options.onEmpty,
                    delayedCapture: siteStore.checkoutSettings.delayCaptureEnabled,
                }];
        }
    });
}); };
//# sourceMappingURL=getPaymentMethodsBannerProps.js.map